import { gql, useMutation } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';

import { AnonCriteriaFragment, AUA_DETAILS_PAGE_PATH, TOAST_ACTIONS } from '../constants';
import { getFailureDisplayMessage } from '../utils';

export const createAnonCriteriaQuery = gql`
  mutation CreateAnonCriteria($criteria: EditableAnonUserCriteriaInput!) {
    createAnonUserCriteria(criteria: $criteria) {
      payload {
        ...AnonCriteria
      }
      failure {
        ... on AnonUserCriteriaCreationFailure {
          message
        }
        ... on AnonUserCriteriaInvalidSearchQuery {
          message
        }
        ... on AnonUserCriteriaNameAlreadyExistsFailure {
          message
        }
        ... on AnonUserCriteriaNotFoundFailure {
          message
        }
        ... on AnonUserCriteriaUpdateFailure {
          message
        }
      }
    }
  }
  ${AnonCriteriaFragment}
`;

export const useCreateAnonCriteria = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [createCriteria, { loading, error, data }] = useMutation(createAnonCriteriaQuery, {
    onCompleted: (res) => {
      const createdId = res?.createAnonUserCriteria?.payload?.id;
      if (res?.createAnonUserCriteria?.failure?.message) {
        const failureMessage = getFailureDisplayMessage(
          res?.createAnonUserCriteria?.failure?.message,
        );
        dispatch(
          addNegativeToastWithErrorId(
            failureMessage,
            TOAST_ACTIONS.createCriteria,
            new Error(failureMessage),
          ),
        );
      } else {
        history.push(AUA_DETAILS_PAGE_PATH(createdId));
        dispatch(
          addPositiveToast(
            `${res?.createAnonUserCriteria?.payload?.fields?.name} created successfully`,
          ),
        );
      }
    },
    onError: (e) => {
      dispatch(
        addNegativeToastWithErrorId(
          'There was an error creating the unknown user criteria. Please try again.',
          TOAST_ACTIONS.createCriteria,
          e,
        ),
      );
    },
  });

  return {
    createCriteria,
    loading,
    error,
    hasCustomError: data?.createAnonUserCriteria?.failure || error,
  };
};
